import styles from "./TextLineAround.module.scss";
import React from "react";

export const TextLineAround = ({children}) => {
  return <div className={styles.text}>{children}</div>
}
